import { createTheme } from '@mui/material/styles';

// App-wide default theme. The Explore workbench uses its own scoped theme
// (see src/pages/explore/exploreTheme.ts) layered via a nested ThemeProvider.
const theme = createTheme({
  palette: {
    primary: {
      main: '#333333', // Dark grey as primary
    },
    secondary: {
      main: '#888888', // Optional: lighter grey
    },
    background: {
      default: '#f5f5f5', // Light background
    },
  },
});

export default theme;
